import React, { useState, useRef } from 'react';
import AlenaGoriachaia from "../../../photos/alona-main.jpg";
import MikhailoGoriachii from "./photos/MikhailoGoriachii.jpg";
import nikolay from "./photos/nikolay.jpg";
import natalia2 from "./photos/natalia2.jpg";
import olena from "./photos/olena.jpg";
import oksana from "./photos/oksana.jpg";
import vadim from "./photos/Vadim.jpg";
import annanovikova from "./photos/annanovikova.jpg";

const employees = [
  { fullName: 'Горяча Альона Юріївна', position: 'Керівник. Досвід у сфері транспортної логістики 18 років.', phone: '+380966341617', img: AlenaGoriachaia },
  { fullName: 'Субота Михайло Юрійович', position: 'Логіст. Готовий вирішити будь-яке ваше питання 24/7. Розмовна англійська, польська.', phone: '+380670001028', img: MikhailoGoriachii },
  { fullName: 'Шевченко Микола Григорович', position: 'Куратор логістичного відділу.', phone: '+380675589292', img: nikolay },
  { fullName: 'Хлівна Наталя Юріївна', position: 'Фахівець з транспортування товарів народного споживання', phone: '+380670001460', img: natalia2 },
  { fullName: 'Кириченко Олена Миколаївна', position: 'Керівник відділу експедитування з міжнародних напрямків, спеціаліст з транспортування зернових культур', phone: '+380675047553', img: olena },
  { fullName: 'Сливка Вадим Ігорович', position: 'Логіст відділу великогабаритного транспорту', phone: '+380670110411', img: vadim },
  { fullName: 'Оксана Сергіївна', position: 'Помічник головного бухгалтера з красивими очима', phone: '+380633974840', img: oksana },
  { fullName: 'Анна Новікова', position: 'Логіст, колишня полісмен, відповідальна людина, приватний охоронець твого вантажу', phone: '+380770310101', img: annanovikova },
];

function Employees() {
  const [active, setActive] = useState(0);
  const sectionRef = useRef(null);
  const touchStartX = useRef(null);

  const goTo = (i) => {
    setActive(i);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(dx) > 50) {
      if (dx < 0) setActive(i => Math.min(i + 1, employees.length - 1));
      else setActive(i => Math.max(i - 1, 0));
    }
    touchStartX.current = null;
  };

  const emp = employees[active];

  const phonePretty = (phone) => {
    const g = phone.substr(0, 3);
    const c = phone.substr(3, 3);
    const p1 = phone.substr(6, 3);
    const p2 = phone.substr(9, 2);
    const p3 = phone.substr(11, 2);
    return `${g} (${c}) ${p1} ${p2} ${p3}`;
  };

  return (
    <section ref={sectionRef} style={{
      padding: '120px 24px',
      background: '#0a0a0f',
    }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(24px, 4vw, 40px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 60,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          Наша <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>команда</span>
        </h2>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16, maxWidth: 880, margin: '0 auto' }}>
          {/* Prev arrow */}
          <button
            onClick={() => setActive(i => Math.max(i - 1, 0))}
            disabled={active === 0}
            style={{
              flexShrink: 0,
              border: 'none',
              background: 'transparent',
              color: active === 0 ? 'rgba(255,255,255,0.2)' : '#4dc247',
              fontSize: 32,
              cursor: active === 0 ? 'default' : 'pointer',
              padding: '0 8px',
              transition: 'all 0.2s ease',
              lineHeight: 1,
            }}
          >‹</button>

        <div
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          style={{
          display: 'flex',
          alignItems: 'center',
          gap: 60,
          flexWrap: 'wrap',
          justifyContent: 'center',
          flex: 1,
        }}>
          {/* Photo */}
          <div style={{
            width: 280,
            height: 280,
            borderRadius: '50%',
            overflow: 'hidden',
            border: '3px solid rgba(22,183,36,0.3)',
            boxShadow: '0 0 60px rgba(22,183,36,0.15)',
            flexShrink: 0,
            position: 'relative',
          }}>
            <img
              key={active}
              src={emp.img}
              alt={emp.fullName}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                animation: 'fadeIn 0.5s ease',
              }}
            />
          </div>

          {/* Info */}
          <div style={{ flex: 1, minWidth: 250, textAlign: 'center' }}>
            <div key={active} style={{ animation: 'fadeIn 0.5s ease' }}>
              <h3 style={{
                fontSize: 26,
                fontWeight: 700,
                color: '#fff',
                marginBottom: 10,
              }}>
                {emp.fullName}
              </h3>
              <p style={{
                fontSize: 16,
                color: 'rgba(255,255,255,0.6)',
                marginBottom: 24,
                lineHeight: 1.6,
              }}>
                {emp.position}
              </p>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
                <a href={`tel:${emp.phone}`} style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '12px 24px',
                  background: 'linear-gradient(135deg, #16b724, #0e8a1a)',
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 600,
                  textDecoration: 'none',
                  borderRadius: 50,
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 20px rgba(22,183,36,0.3)',
                }}
                onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseOut={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  {phonePretty(emp.phone)}
                </a>
                <a href={`viber://chat?number=%2B${emp.phone.replace('+', '')}`} style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '12px 24px',
                  background: 'transparent',
                  color: '#4dc247',
                  fontSize: 14,
                  fontWeight: 600,
                  textDecoration: 'none',
                  borderRadius: 50,
                  border: '1px solid rgba(22,183,36,0.4)',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={e => {
                  e.currentTarget.style.background = 'rgba(22,183,36,0.1)';
                }}
                onMouseOut={e => {
                  e.currentTarget.style.background = 'transparent';
                }}
                >
                  Viber
                </a>
              </div>
            </div>

            {/* Dots nav */}
            <div style={{
              display: 'flex',
              gap: 8,
              marginTop: 32,
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}>
              {employees.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  style={{
                    width: i === active ? 28 : 10,
                    height: 10,
                    borderRadius: 5,
                    border: 'none',
                    cursor: 'pointer',
                    background: i === active
                      ? 'linear-gradient(135deg, #16b724, #4dc247)'
                      : 'rgba(255,255,255,0.15)',
                    transition: 'all 0.3s ease',
                  }}
                />
              ))}
            </div>
          </div>
        </div>

          {/* Next arrow */}
          <button
            onClick={() => setActive(i => Math.min(i + 1, employees.length - 1))}
            disabled={active === employees.length - 1}
            style={{
              flexShrink: 0,
              border: 'none',
              background: 'transparent',
              color: active === employees.length - 1 ? 'rgba(255,255,255,0.2)' : '#4dc247',
              fontSize: 32,
              cursor: active === employees.length - 1 ? 'default' : 'pointer',
              padding: '0 8px',
              transition: 'all 0.2s ease',
              lineHeight: 1,
            }}
          >›</button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </section>
  );
}

export default Employees;
